const UserType = {
    CHANGE_USER_ACTION: "CHANGE_USER_ACTION",
    
}

export default UserType;